module.exports = __webpack_public_path__ + "img/yanshufgreen.3b9aa362.svg";